import products from "@/data/products/products";
import { useRouter } from "next/router";
import Link from "next/link";
import { m } from "framer-motion";
import { useTranslation } from "next-i18next";

const ProductNav = () => {
  const { i18n } = useTranslation();
  const rtl = i18n.dir() === "rtl";
  return (
    <m.nav
      className="card flex w-full flex-col items-start gap-4 p-4 lg:w-72"
      initial={{ x: rtl ? 100 : -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="text-2xl font-bold text-auto-black/70">All Products</div>
      <div className="h-px w-full bg-auto-black/20"></div>
      <div className="flex w-full flex-col items-start gap-4">
        {products.map((product) => (
          <ProductLink key={product.code} product={product} />
        ))}
      </div>
    </m.nav>
  );
};

export default ProductNav;

const ProductLink = ({ product }) => {
  const { asPath } = useRouter();
  const isActive = asPath === `/product/${product.code}`;
  return (
    <Link
      href={`/product/${product.code}`}
      className={`${isActive ? "font-bold text-auto-black/80" : "text-auto-black/60"}  hover:text-auto-black/90`}
    >
      {product.name}
    </Link>
  );
};
